// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3XKe5","large":"styles_large__1ItQx"};